<template>
    <div class="new-chat-contacts">
        <new-chat-source-filter :value="activeSource" @input="handleSourceChange" />

        <new-chat-tabs v-if="activeSource !== 'ai'" :selected="activeTab" @click="handleTabClick" />

        <v-preloader v-if="isLoading" class="preloader_type_button" size="small" />

        <template v-if="!isLoading">
            <new-chat-common-list v-if="activeSource === 'ai' || activeTab === 'common'"      @select="$emit('select', $event)" />
            <new-chat-my-list     v-else-if="activeTab === 'personal'" @select="$emit('select', $event)" />
        </template>
    </div>
</template>

<script>
import api from '@api'
import { mapGetters, mapActions } from 'vuex'
import NewChatSourceFilter from './NewChatSourceFilter.vue'
import NewChatTabs from './NewChatTabs.vue'
import NewChatCommonList from './NewChatCommonList.vue'
import NewChatMyList from './NewChatMyList.vue'
import vPreloader from '../../global/Preloader.vue'

export default {
    name: 'NewChatContacts',
    components: {
        NewChatSourceFilter,
        NewChatTabs,
        NewChatCommonList,
        NewChatMyList,
        vPreloader,
    },
    computed: {
        ...mapGetters('newChat', ['activeTab', 'activeSource', 'isLoading']),
    },
    mounted() {
        this.fetchList()
    },
    methods: {
        ...mapActions('newChat', ['setTab', 'setSource', 'setLoading', 'setList']),

        handleTabClick(tab) {
            if (tab === this.activeTab) return
            this.setTab(tab)
            this.fetchList()
        },

        handleSourceChange(source) {
            if (source === this.activeSource) return
            this.setSource(source)
            this.fetchList()
        },

        fetchList() {
            this.setLoading(true)
            const params = { source: this.activeSource, type: this.activeSource === 'ai' ? 'common' : this.activeTab }
            api.newChat.getList(params)
                .then(response => {
                    this.setList(Array.isArray(response) ? response : [])
                })
                .catch(err => {
                    console.error('[NewChat] list error:', err)
                    this.setList([])
                })
                .finally(() => {
                    this.setLoading(false)
                })
        },

    },
}
</script>
